/* unplugin-vue-components disabled */import { render } from "./Addons.vue?vue&type=template&id=fc389ca2&ts=true"
import script from "./Addons.vue?vue&type=script&lang=ts"
export * from "./Addons.vue?vue&type=script&lang=ts"

import "./Addons.vue?vue&type=style&index=0&id=fc389ca2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__